import * as React from 'react';
import Svg, {SvgProps, Circle, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg width={56} height={56} fill="none" {...props}>
    <Circle cx={28} cy={28} r={28} fill="#D7EBFB" />
    <Path
      stroke="#203040"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.702 21.363a4.374 4.374 0 1 0 0-8.747 4.374 4.374 0 0 0 0 8.747ZM15.577 29.237v2.935a2.666 2.666 0 0 0 2.666 2.666h1.707v3.675h-5.034a2.666 2.666 0 0 1-2.666-2.667V26.76a3.295 3.295 0 0 1 3.293-3.293h3.531l1.6 2.4a1.473 1.473 0 0 0 2.434.025l1.564-2.249h.942a3.295 3.295 0 0 1 3.294 3.294v1.431"
    />
    <Path
      stroke="#203040"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M46.375 28.364H28.701L25.9 40.76h17.675l2.8-12.395ZM20.127 35.39h3c1.09 0 1.974.885 1.974 1.973v1.067h-4.974v-3.04Z"
    />
    <Path
      stroke="#203040"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M36.138 35.805a.967.967 0 1 0 0-1.934.967.967 0 0 0 0 1.934Z"
    />
  </Svg>
);

export default SvgComponent;
